import React from 'react'
import { AppDataContext } from '../app-data-provider'

function useAppData () {
  return React.useContext(AppDataContext)
}

export default useAppData
